<template>
  <div class="grided-template">
    <MenuComponent></MenuComponent>
    <div>
      <default-header :visible="headerVisibility"></default-header>
      <div class="otimizador-main-screen">
        <OtimizadorStep v-if="showStepData" :steps="steps"></OtimizadorStep>
        <OtimizadorSettings :class="{ 'headerAproach': headerVisibility == true }" v-else :card="cardData"
          @collumsToHide="hideOrShowCollums" @visibilityMode="visibilityModeChanged" @changeCenario="changeCenario"
          @updateCenarioRequest="updateCenarioRequest" @moveToOriginalCenario="moveToOriginalCenario"
          @generateExcell="generateExcell" @removeScenario="removeScenario" @update:feedBackMode="feedBackMode = $event"
          :feedBackMode="feedBackMode" :nrcenario="nrcenario" :cenarios="cenarios"></OtimizadorSettings>
        <div v-if="shouldLoad && notShowingCard" class="loader" v-bind:style="'background-image: url(' + loader + ')'">
          <span class="timer" v-if="loader == otloader">
            <div class="timer-center">
              <span id="hora"></span>
              <span id="minuto"></span>
              <span id="segundo"></span>
            </div>
          </span>
        </div>

        <div class="loading-gif" :class="{ 'visible': showSmallLoader }">
          <img :src="loadingGif" />
        </div>

        <div class="otimizador-container" v-bind:class="{ 'loading': shouldLoad == true }">
          <div v-if="showStepData" class="arrow" v-on:click="stepManager" v-bind:style="unclickable">
            <span class="arr">
              <span>▶</span>
            </span>
            <span class="desc">{{ $t('advance') }}</span>
          </div>

          <div v-if="loaded == false && shouldLoad == false && notShowingCard">
            <RegisteredData :updateRegisteredData="updateRegisteredData" :cardData="cardData"></RegisteredData>
          </div>

          <div v-if="showUnconsideredPlates == true">
            <UnconsideredPlatesList :dataFromOtm="dataFromOtm" @chooseAction="callNextStep"></UnconsideredPlatesList>
          </div>

          <div v-if="loaded == true && shouldLoad == false && notShowingCard" class="data-from-food">
            <OtimizadorData :dataFromOtm="dataFromOtm" @editedData="feedData"></OtimizadorData>
          </div>

          <div v-if="notShowingCard == false" class="card-container" ref="cardContainerElement"
            :class="{ 'empty': cardDataNormalizada.length == 0 }">
            <div v-if="cardDataNormalizada.length == 0" class="card-usg-warning">
              <div class="warning" :class="{ 'hideBugIcon': cenarios.length == 0 }">
                <span v-if="cenarios.length > 0">
                  {{ $t('info_scenery') }}
                  <div>...</div>{{ $t('info_2_scenery') }}
                </span>
                <span v-else>{{ $t('there_is_no_scenario_generated') }}</span>
              </div>
            </div>
            <AnalResult v-if="cardDataNormalizada.length != 0" :cardData="cardData" :hideColuns="collumsTohideOrShow"
              :exibitionMode="exibitionMode" :nrcenario="nrcenario" :feedBackMode="feedBackMode" :ingrColors="ingrColors" ,
              @update:feedBackMode="feedBackMode = $event" @updateCenarioFromPlateSub="updateCenarioFromPlateSub"
              @logBuracosExcel="logBuracosExcel" @regerar-cardapio-ia="regerarCardapioIA"></AnalResult>

            <div
              v-if="cardDataNormalizada.length != 0 && cardData?.dataCatalog?.ignoredRules && Object.keys(cardData?.dataCatalog?.ignoredRules)?.length != 0"
              class="card-container-result">
              <FlexibleRulesComponent :cardData="cardData"></FlexibleRulesComponent>
            </div>

            <div v-if="cardDataNormalizada.length != 0" class="card-container-result">
              <AnalDataContainer :drilldownData="drilldownData"></AnalDataContainer>
            </div>
            <div class="chat-container" v-if="chartData && chartData.serieAnalisePU.length > 0">
              <div class="title">{{ $t('analyze_PU') }}</div>
              <VueApexCharts class="chart" :width="chartWidth" :height="chartHeight" type="line"
                :options="chartData.optionsAnalisePU" :series="chartData.serieAnalisePU"></VueApexCharts>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getSocketInstance } from '@/main.js';
import Util from "@/application/libs/util";
import MenuComponent from "@/components/src/MenuComponent";
import OtimizadorStep from "@/components/src/OtimizadorStep";
import OtimizadorSettings from "@/components/src/OtimizadorSettings";
import OtimizadorData from "@/components/src/OtimizadorData";
import DefaultHeader from "@/components/src/DefaultHeaderComponent";
import AnalResult from "@/components/src/AnalResultComponent";
import AnalDataContainer from "@/components/src/AnalDataContainer";
import RegisteredData from "@/components/src/RegisteredDataComponent";
import UnconsideredPlatesList from "@/components/src/UnconsideredPlatesListComponent";
import EventModule from "@/application/libs/eventModule";
import requestModule from "@/application/libs/requestModule";
import OptimizerController from "../controllers/OptimizerController";
import ExcelBuilder from "@/application/libs/excelBuilder";
import { t } from 'i18next';
import FlexibleRulesComponent from "@/components/src/FlexibleRulesComponent";

import VueApexCharts from "vue-apexcharts";

export default {
  name: "Optimizer",
  components: {
    DefaultHeader,
    MenuComponent,
    OtimizadorStep,
    OtimizadorSettings,
    OtimizadorData,
    AnalDataContainer,
    FlexibleRulesComponent,
    AnalResult,
    RegisteredData,
    VueApexCharts,
    UnconsideredPlatesList
  },

  data() {
    return {
      view: {
        title: t('optimizer')
      },
      showUnconsideredPlates: false,
      bipSound: require("../../../static/bip.mp3"),
      chartHeight: 500,
      chartWidth: 500,
      updateRegisteredData: true,
      headerVisibility: true,
      showSmallLoader: false,
      feedBackMode: false,
      nrcenario: null,
      cenarios: [],
      collumsTohideOrShow: [],
      showStepData: true,
      timer: null,
      editedData: null,
      unclickable: null,
      currentStep: 0,
      shouldLoad: false,
      notShowingCard: true,
      loader: "",
      loaded: false,
      data: null,
      cardData: {},
      exibitionMode: null,
      steps: [
        {
          name: t('gather_registered_data'),
          active: false
        },
        {
          name: t('confirm_parameters'),
          active: false
        },
        {
          name: t('generate_menu'),
          active: false
        }
      ],
      dtloader: require("../../../static/otimizadordata.gif"),
      otloader: require("../../../static/otimizador.gif"),
      loadingGif: require("../../../static/ic-logo.gif"),
    };
  },
  computed: {
    cardDataNormalizada() {
      if (this.cardData?.tabela?.pratos) {
        return this.cardData.tabela.pratos;
      }

      if (this.cardData?.dataCatalog?.tabela) {
        return this.cardData.dataCatalog.tabela;
      }
      return [];
    },
    ingrColors() {
      if (!this.cardData) return null;
      return OptimizerController.feedINGData(this.cardData);
    },
    drilldownData() {
      const catalog = this.cardData?.dataCatalog;
      if (!catalog) return [];
      return OptimizerController.buildDrilldown(catalog);
    },
    chartData() {
      if (!this.cardData?.dataCatalog) return null;
      return OptimizerController.computeChartData(this.cardData);
    },
  },
  created() {
    EventModule.$on("updateBoData", this.updateRegisteredDataEvent);
    if (this.$router.currentRoute.fullPath == "/ResultAna") {
      EventModule.$on("updateBoData", this.loadCenarios);
    }
  },
  watch: {
    chartData(val) {
      if (val) {
        this.chartWidth  = document.documentElement.clientWidth  / 1.1;
        this.chartHeight = document.documentElement.clientHeight / 1.3;
      }
    }
  },
  beforeDestroy() {
    EventModule.$off("updateBoData", this.loadCenarios);
    EventModule.$off("updateBoData", this.updateRegisteredDataEvent);
    this.cardData && Object.keys(this.cardData).forEach(k => delete this.cardData[k]);
  },

  mounted() {
    document.title = `${this.view.title} - Cardápio Inteligente`;
    this.performedFirstTopScrollOnAnalytics = false;

    if (this.$router.currentRoute.fullPath == "/ResultAna") {
      // this.headerVisibility = false;
      this.loaded = false;
      this.shouldLoad = false;
      this.notShowingCard = false;
      this.showStepData = false;
      this.cardData = {
        tabela: { pratos: [] },
        backOfficeData: {
          costType: { NMTIPOCUSTO: "" },
          DTREFECUSTO: ""
        },
        meta: { VLR_CUSTO_MIN: null },
        dataCatalog: {}
      };

      this.loadCenarios();
    } else {
      this.steps.map(st => (st.active = false));
      this.steps[0].active = true;
    }
  },
  methods: {
    playBeep: function () {
      var audio = new Audio(this.bipSound);
      audio.play();
    },
    updateRegisteredDataEvent: function () {
      if (this.currentStep != 0) {
        window.location.reload();
      }
      this.updateRegisteredData = !this.updateRegisteredData;
    },
    updateCenarioRequest: function (data) { },
    hideOrShowCollums: function (data) {
      this.collumsTohideOrShow = data;
    },
    updateCenarioFromPlateSub: function (newCardData) {
      this.cardData = newCardData;
      this.showStepData = false;
      this.insertCenario(this.nrcenario.NRCENARIOCARD);
    },
    regerarCardapioIA: function () {
      this.showStepData = false;
      this.insertCenario(null);
    },
    moveToOriginalCenario: function (data) {
      let cenario = this.cenarios.find(c => c.NRCENARIOCARD == data);
      this.changeCenario(cenario);
    },
    compExcellBuilder: function () {
      let incListCopy = JSON.parse(JSON.stringify(this.cardData.incidencia));
      let { label, data } = OptimizerController.generateCompExcell(
        OptimizerController.buildDiasFromCatalog(this.cardData.dataCatalog),
        incListCopy,
        OptimizerController.buildColInfoFromCatalog(this.cardData.dataCatalog),
        OptimizerController.getPuAcumlFromCatalog(this.cardData.dataCatalog)
      );
      var title = Util.getExcelHeaderFromFilter();
      const conditionalFormatterRules = [
        {
          "type": "cellIs",
          "formulae": [
            "0"
          ],
          "operator": "greaterThan",
          "style": {
            "font": {
              "color": {
                "argb": "FFFF0000"
              }
            }
          }
        },
        {
          "type": "cellIs",
          "formulae": [
            "0"
          ],
          "operator": "lessThan",
          "style": {
            "font": {
              "color": {
                "argb": "FF008000"
              }
            }
          }
        }
      ]
      title = t('comparative_optimized_menu') + ' ' + title[0].value.replace(/\//g, "-") + ', ' + t('unit') + ' ' + title[3].value + ', ' + t('service') + ' ' + title[5].value;
      const columnLetter = (index) => String.fromCharCode(65 + index); // A=65 no ASCII
      // Localiza os índices pelos keys desejados
      const desiredKeys = ['puotmmescorrente', 'puotmmediapu'];
      const columnRefs = desiredKeys.map(key => {
        const columnIndex = label.findIndex(col => col.key === key);
        return columnIndex !== -1 ? `${columnLetter(columnIndex)}5:${columnLetter(columnIndex)}65536` : null;
      }).filter(ref => ref !== null); // Remove referências nulas

      // Modifica valores nulos apenas na primeira linha de `data`
      if (data[0]) {
        const firstRow = data[0];
        // Coleta todas as chaves existentes nos objetos de `data`
        const allKeys = new Set();
        data.forEach((row) => {
          Object.keys(row).forEach((key) => allKeys.add(key));
        });

        // Adiciona chaves ausentes em `data[0]` com valor '--'
        allKeys.forEach((key) => {
          if (!(key in firstRow)) {
            firstRow[key] = "--";
          }
        });
        Object.keys(firstRow).forEach((key) => {
          if (firstRow[key] === null) {
            firstRow[key] = "--";
          }
        });
      }

      ExcelBuilder.fromJson(
        data,
        label,
        title,
        [].concat(Util.getExcelHeaderFromFilter(), [
          { label: t('scenery'), value: this.nrcenario.NRCENARIOCARD }
        ]),
        {
          options: {
            views: [
              { state: 'frozen', ySplit: 5, xSplit: 2 }
            ]
          },
          conditionalFormatting: columnRefs.map(ref => ({ ref, rules: conditionalFormatterRules })), // Aplica regras para as colunas encontradas
        }
      );
    },
    cardExcellBuilder: function (format) {
      let { label, data } = OptimizerController.generateCardExcell(this.cardData.dataCatalog, format === 'numero');
      var title = Util.getExcelHeaderFromFilter();
      title = t('optimized_menu') + ' ' + title[0].value.replace(/\//g, "-") + ', ' + t('unit') + ' ' + title[3].value + ', ' + t('service') + ' ' + title[5].value;
      ExcelBuilder.fromJson(
        data,
        label,
        title,
        [].concat(Util.getExcelHeaderFromFilter(), [
          { label: t('scenery'), value: this.nrcenario.NRCENARIOCARD }
        ])
      );
    },
    logBuracosExcel: function () {
      let { label, newArrExcel } = OptimizerController.generatelogBuracosExcel(this.cardData.cardapio.datas);
      var title = Util.getExcelHeaderFromFilter();
      title = t('inconsistencies_in_the_scenario') + ' ' + title[0].value.replace(/\//g, "-") + ', ' + t('unit') + ' ' + title[3].value + ', ' + t('service') + ' ' + title[5].value;
      const conditionalFormatterRules = [{
        "type": "cellIs",
        "formulae": [
          "0"
        ],
        "operator": "greaterThan",
        "style": {
          "font": {
            "color": {
              "argb": "FFFF0000"
            }
          }
        }
      },
      {
        "type": "cellIs",
        "formulae": [
          "0"
        ],
        "operator": "lessThan",
        "style": {
          "font": {
            "color": {
              "argb": "FF008000"
            }
          }
        }
      }]

      ExcelBuilder.fromJson(
        newArrExcel,
        label,
        title,
        [].concat(Util.getExcelHeaderFromFilter(), [
          { label: t('scenery'), value: this.nrcenario.NRCENARIOCARD }
        ]),
        {
          options: {
            views: [
              { state: 'frozen', ySplit: 4, xSplit: 2 }
            ]
          },
          conditionalFormatting: [
            { ref: "R5:R65536", rules: conditionalFormatterRules },
            { ref: "T5:T65536", rules: conditionalFormatterRules }
          ]
        }
      );
    },
    generateExcell: function () {
      if (!this.cardData?.dataCatalog?.tabela) {
        return false;
      }
      let sf = this;
      this.$modal.show({
        template: `
              <div id="default-modal">
                <a class="confirm-label">{{$t('which_report_do_you_want_to_issue')}}</a>
                <div class="buttons-container">
                  <!--<div class="button" id="inconsistencia" @click="inconsistencia">
                        {{$t('inconsistencies_in_the_scenario')}}
                  </div>-->

                  <div class="button" id="comparativo" @click="comparativo">
                      {{$t('comparison_menu_vs_scenery')}}
                  </div>

                  <div class="button" id="confirm" @click="numero">
                      {{$t('menu_number_of_diners')}}
                  </div>
                  
                  <div class="button" id="cancel" @click="porcentagem">
                      {{$t('menu_percentage_diners')}}
                  </div>
                </div>
              </div>
          `,
        methods: {
          comparativo() {
            sf.compExcellBuilder();
            this.$emit('close');
          },
          numero() {
            sf.cardExcellBuilder('numero');
            this.$emit('close');
          },
          porcentagem() {
            sf.cardExcellBuilder('porcentagem');
            this.$emit('close');
          },
          inconsistencia() {
            sf.logBuracosExcel();
            this.$emit('close');
          }
        }
      }, {}, {
        height: 'auto',
        resizable: false
      });
    },
    changeCenario: function (newCenario) {
      if (!newCenario) {
        return Promise.resolve();
      }
      this.nrcenario = {
        ...newCenario,
        VERSAORELATORIOIA: null,
        STATUSRELATORIOIA: null,
      };
      this.showSmallLoader = true;
      return requestModule
        .postRequest(`getData`, {
          FROM: "CENARIO",
          PARAMS: {
            NRCENARIOCARD: this.nrcenario.NRCENARIOCARD,
            NRORG: Util.getLocalVar("userData").NRORG
          }
        })
        .then(response => {
          const cenarioSelecionado = response?.dataset?.data?.[0];
          if (!cenarioSelecionado) {
            return;
          }

          this.headerVisibility = false;
          this.nrcenario = {
            ...this.nrcenario,
            VERSAOCENARIO: cenarioSelecionado.VERSAOCENARIO ?? null,
            VERSAORELATORIOIA: cenarioSelecionado.VERSAORELATORIOIA ?? null,
            STATUSRELATORIOIA: cenarioSelecionado.STATUSRELATORIOIA ?? null,
          };

          let parsedCenario = cenarioSelecionado.JSONCENARIO;
          let dataCatalog = cenarioSelecionado.JSONCARDAPIO;
          parsedCenario = JSON.parse(parsedCenario);
          // só faz parse se for string
          if (typeof dataCatalog === 'string') {
            try {
              dataCatalog = JSON.parse(dataCatalog);
            } catch (e) {
              console.error('Erro ao fazer parse do JSONCARDAPIO:', e);
              dataCatalog = null;
            }
          }
          OptimizerController.fixIdPrato(dataCatalog, Util.getFilterInSession().CDFILIAL);

          let rawDate = cenarioSelecionado.DTEXPIRACAO;
          let formattedDate = rawDate ? moment(rawDate, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY") : null;
          parsedCenario.DTEXPIRACAO = formattedDate;
          this.cardData = {
            ...parsedCenario,
            dataCatalog: dataCatalog ?? {}
          };
          const { cardContainerElement } = this.$refs;

          if (!this.performedFirstTopScrollOnAnalytics) {
            this.performedFirstTopScrollOnAnalytics = true;
            setTimeout(
              () => (cardContainerElement.style.scrollSnapType = "y mandatory"),
              1
            );
          }
        })
        .finally(() => {
          this.showSmallLoader = false;
          if(this.cardData?.dataCatalog) console.log("dataCatalog",this.cardData?.dataCatalog);
        });
    },
    removeScenario: function (newCenario) {
      Util.showConfirmationDialog(this.$modal, () => {
        this.showSmallLoader = true;
        requestModule
          .postRequest(`updateData`, {
            FROM: "CENARIOATIVO",
            PARAMS: {
              NRCENARIOCARD: newCenario.NRCENARIOCARD,
              NRORG: Util.getLocalVar("userData").NRORG
            }
          })
          .then(response => {
            // Reset para estado sem cenário selecionado
            this.nrcenario = null;
            this.cardData = {
              tabela: { pratos: [] },
              backOfficeData: {
                costType: { NMTIPOCUSTO: "" },
                DTREFECUSTO: ""
              },
              meta: { VLR_CUSTO_MIN: null },
              dataCatalog: {}
            };
            this.showStepData = false;
            this.notShowingCard = false;
            this.loaded = false;
            this.shouldLoad = false;

            // Recarregar a lista de cenários para remover o deletado
            this.loadCenarios();
          })
          .finally(() => {
            this.showSmallLoader = false;
          });
      }, t('delete_scenario'));
    },
    activefeedBackMode() {
      this.feedBackMode = !this.feedBackMode;
    },
    checkDataFullness: function () {
      if (
        !(
          Util.getFilterInSession().DTMESCARD &&
          Util.getLocalVar("userData").CDOPERADOR &&
          Util.getFilterInSession().VRCUSTPADR &&
          Util.getFilterInSession().VLR_CUSTO_MIN &&
          Util.getFilterInSession().VLR_CUSTO_MAX
        )
      ) {
        Util.showErrorNotification({
          text: t('fill_in_all_the_necessary_data_to_generate_the_menu'),
          title: t('incomplete_data')
        });

        return false;
      }
      return true;
    },
    firstStep: function () {
      EventModule.$emit("next-step-optimizer", 1);
      if (this.checkDataFullness()) {
        this.currentStep++;

        this.unclickable = "pointer-events: none;";
        this.shouldLoad = true;
        this.loader = this.dtloader;

        let reqPar = {
          url_in: `getGenData`,
          P_CDFILIAL: Util.getFilterInSession().CDFILIAL,
          P_CDSERVFILI: Util.getFilterInSession().CDSERVFILI,
          P_DTREFCUSPADR: Util.getFilterInSession().DTMESCARD,
          P_IDTIPORESTRICAO: Util.getFilterInSession().TPCONTRATO,
          P_DTMESCARD: Util.getFilterInSession().DTMESCARD,
          P_NRTIPOCUSTO: Util.getFilterInSession().NRTIPOCUSTO,
          P_DTREFECUSTO: Util.getFilterInSession().DTREFECUSTO,
          P_DTMES: Util.getFilterInSession().DTMESCARD,
          P_DIAS_CONG: Util.getFilterInSession().VLR_CONGELADO,
          P_DIA_SEMANA: Util.getFilterInSession().P_DIA_SEMANA,
          P_CDNVPRATO: Util.getPlateNivel(),
          P_IDUTRPADCA: Util.getFilterInSession().IDUTRPADCA,
          P_CDFILICUSTO: Util.getFilterInSession().CDFILICUSTO
        };

        requestModule
          .postRequest(
            `${reqPar.url_in}?P_CDFILIAL=${reqPar.P_CDFILIAL}&P_CDFILICUSTO=${reqPar.P_CDFILICUSTO}&P_CDSERVFILI=${reqPar.P_CDSERVFILI}&P_DTREFCUSPADR=${reqPar.P_DTREFCUSPADR}&P_IDTIPORESTRICAO=${reqPar.P_IDTIPORESTRICAO}&P_DTMESCARD=${reqPar.P_DTMESCARD}&P_NRTIPOCUSTO=${reqPar.P_NRTIPOCUSTO}&P_DTREFECUSTO=${reqPar.P_DTREFECUSTO}&P_DTMES=${reqPar.P_DTMES}&P_DIAS_CONG=${reqPar.P_DIAS_CONG}&P_DIA_SEMANA=${reqPar.P_DIA_SEMANA}&P_CDNVPRATO=${reqPar.P_CDNVPRATO}&P_IDUTRPADCA=${reqPar.P_IDUTRPADCA}`,
            {}
          )
          .then(response => {
            this.shouldLoad = false;
            this.loaded = true;
            this.loader = "";


            this.dataFromOtm = response.dataset;
            this.dataFromOtm = OptimizerController.addIncidencia_tp_gp_prato(this.dataFromOtm);

            this.steps[1].active = true;
            this.headerVisibility = false;
          })
          .catch(error => {
            console.log(error);
            this.currentStep = 0;
          })
          .finally(() => {
            this.unclickable = "pointer-events: auto;";
          });
      } else {
        this.currentStep = 0;
      }
    },
    feedData: function (data) {
      this.editedData = Object.assign({}, data);
    },
    insertCenario: function (NRCENARIOCARD = null) {
      const { dataCatalog, ...cardData } = this.cardData;
      requestModule
        .postRequest(`insertData`, {
          FROM: "CENARIO",
          PARAMS: {
            NRCENARIOCARD,
            CDFILIAL: Util.getFilterInSession().CDFILIAL,
            CDFILICUSTO: Util.getFilterInSession().CDFILICUSTO,
            CDSERVFILI: Util.getFilterInSession().CDSERVFILI,
            DTMESCARD: Util.getFilterInSession().DTMESCARD,
            CDOPERADOR: Util.getLocalVar("userData").CDOPERADOR,
            JSONCENARIO: JSON.stringify(cardData),
            correlationId: cardData.correlationId ?? null,
            JSONCARDAPIO: JSON.stringify(dataCatalog),
            VRCUSTPADR: this.cardData.P_VRCUSTPADR,
            IDTIPORESTRICAO: Util.getFilterInSession().TPCONTRATO,
            QTCOMENSAIS: this.cardData.comensal_total,
            VRPUCENARIO: this.cardData.pu_aculm
              ? this.cardData.pu_aculm.toFixed(5)
              : "",
            NRTIPOCUSTO: Util.getFilterInSession().NRTIPOCUSTO || null,
            DTREFECUSTO: Util.getFilterInSession().DTREFECUSTO || null,
            NRCENARIOVINCULO: Util.getFilterInSession().NRCENARIOVINCULO || null,
            NRORG: Util.getLocalVar("userData").NRORG,
          },
        })
        .then((response) => {
          Util.showSuccessNotification({
            text: `Salvo às ${moment().format("HH:mm:ss")}`,
            title: t('saved_scenario'),
          });
          if (response) {
            let nrcenarioResp = response.dataset.data.NRCENARIOCARD;
            let versaoCenarioResp = response.dataset.data.VERSAOCENARIO ?? null;
            let versaoRelatorioIAResp = response.dataset.data.VERSAORELATORIOIA ?? null;
            let statusRelatorioIAResp = response.dataset.data.STATUSRELATORIOIA ?? null;
            if (this.nrcenario && parseInt(this.nrcenario.NRCENARIOCARD) === parseInt(nrcenarioResp)) {
              this.nrcenario = {
                ...this.nrcenario,
                VERSAOCENARIO: versaoCenarioResp,
                VERSAORELATORIOIA: versaoRelatorioIAResp,
                STATUSRELATORIOIA: statusRelatorioIAResp
              };
            }
            this.loadCenarios(nrcenarioResp, {
              scenarioStateFromInsert: {
                VERSAOCENARIO: versaoCenarioResp,
                VERSAORELATORIOIA: versaoRelatorioIAResp,
                STATUSRELATORIOIA: statusRelatorioIAResp
              }
            });
            this.playBeep();
            if (NRCENARIOCARD && response.dataset.data.NRITGERACAOCARD) { // updateScenary
              const {
                NRGERACAOCARD,
                NRITGERACAOCARD,
                NRCENARIOPUBLICAR
              } = response.dataset.data;
              let socket = getSocketInstance();
              if (socket.connected === true) {
                requestModule.postRequestOtmNode('notifyClients', {
                  EVENT_NAME: 'onUpdateScenary',
                  MESSAGE: {
                    NRGERACAOCARD,
                    NRITGERACAOCARD,
                    NRCENARIOPUBLICAR
                  }
                });
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    callNextStep: function (action) {
      if (action) {
        this.secondStep();
      }
      this.showUnconsideredPlates = false;
    },
    removeReceitaPratoIfNotFrequencia: function (cloneData, cloneEditedData) {
      if ((cloneEditedData.frq_grupo_prato_mes.find(f => f.withoutFreq) && cloneEditedData.frq_grupo_prato_mes.find(f => f.withoutFreq).Ativo == false) && cloneData.frq_grupo_prato_mes.data.length) {
        cloneData.receita_prato.data = cloneData.receita_prato.data.filter(p => cloneData.frq_grupo_prato_mes.data.find(f => f.NUM_GRP_PRATO == p.NUM_GRP_PRATO));
      }
      cloneEditedData.frq_grupo_prato_mes.pop();
    },
    // função para remover pratos inativos e com preço negativo
    removeInativoEsemPreço: function (cloneData) {
      // cloneData.receita_prato.data = cloneData.receita_prato.data.filter(p => p.IDPRODATIVPR == "S" && p.IDPRODATIV == "A");
      cloneData.receita_prato.data = cloneData.receita_prato.data.filter(p => {
        const produtoAtivo = p.IDPRODATIVPR === "S" && p.IDPRODATIV === "A";
        const semCusto = !p.semCusto;
        return produtoAtivo && semCusto;
      });
    },
    secondStep: function () {
      this.unclickable = "pointer-events: none;";
      let cloneData = JSON.parse(JSON.stringify(this.dataFromOtm));
      let cloneEditedData = Object.assign({}, this.editedData);
      let cons = Object.keys(this.editedData);
      this.removeReceitaPratoIfNotFrequencia(cloneData, cloneEditedData);
      this.removeInativoEsemPreço(cloneData);
      for (let i = 0; i < cons.length; i++) {
        const dataSource = cons[i];
        delete cloneEditedData[dataSource].Ativo;
        cloneData[dataSource].data = this.editedData[dataSource].filter(
          ds => ds.Ativo != false
        );
      }
      this.shouldLoad = true;
      this.loader = this.otloader;

      let s = 1;
      let m = 0;
      let h = 0;
      this.timer = window.setInterval(function () {
        if (s == 60) {
          m++;
          s = 0;
        }
        if (m == 60) {
          h++;
          s = 0;
          m = 0;
        }
        if (h < 10) document.getElementById("hora").innerHTML = "0" + h + "h:";
        else document.getElementById("hora").innerHTML = h + "h:";
        if (s < 10)
          document.getElementById("segundo").innerHTML = "0" + s + "s";
        else document.getElementById("segundo").innerHTML = s + "s";
        if (m < 10)
          document.getElementById("minuto").innerHTML = "0" + m + "m:";
        else document.getElementById("minuto").innerHTML = m + "m:";
        s++;
      }, 1000);

      cloneData.P_DTMES = Util.getFilterInSession().DTMESCARD;
      cloneData.CDOPERADOR = Util.getLocalVar("userData").CDOPERADOR;
      cloneData.P_VRCUSTPADR = Util.getFilterInSession().VRCUSTPADR;
      cloneData.VLR_CUSTO_MIN = Util.getFilterInSession().VLR_CUSTO_MIN;
      cloneData.VLR_CUSTO_MAX = Util.getFilterInSession().VLR_CUSTO_MAX;
      cloneData.parsedCardapio = JSON.parse(Util.getFilterInSession().parsedCardapio)

      requestModule
        .postRequest(`caloptServer`, {
          cloneData
        })
        .then(response => {
          response = response && response.dataset && response.dataset.cardIntStatus;
          if (typeof (response && response[0]) == 'string') {
            response = JSON.parse(response[0]);
          }

          if (response.sucesso) {
            this.steps[2].active = true;
            this.shouldLoad = false;
            this.notShowingCard = false;
            if(response.data.dataCatalog){
              OptimizerController.fixIdPrato(response.data.dataCatalog, Util.getFilterInSession().CDFILIAL);
            }
            this.cardData = response.data;
            this.showStepData = false;
            this.cardData.backOfficeData = Util.getFilterInSession();
            this.cardData.incidencia = this.dataFromOtm.incidencia;

            this.insertCenario(null);
          } else {
            let error = response;
            Util.showErrorNotificationFixed({
              text:
                t(error.otmmessage) ||
                t('reload_the_page_and_try_again'),
              title: t(error.title) || t('error_contacting_the_server')
            });
            console.log(error);
          }
        })
        .catch(error => {
          Util.showErrorNotification({
            text: t('reload_the_page_and_try_again'),
            title: t('error_contacting_the_server')
          });
          console.log(error);
        })
        .finally(() => {
          window.clearInterval(this.timer);
        });
    },
    stepManager: function () {
      if (this.currentStep == 0) {
        if (Util.getFilterInSession() && Util.getFilterInSession().VLR_CONGELADO > 0) {
          let sf = this;
          this.$modal.show({
            template: `
                  <div id="default-modal">
                      <a class="confirm-label">{{$t('menu_generated_with_frozen_days', {PARAM: ${Util.getFilterInSession().VLR_CONGELADO}})}}</a>
                      <div class="buttons-container">
                          <div class="button" style="width: 50%" id="confirm" @click="prosseguir(true)">
                              {{$t('confirm')}}
                          </div>
                          
                          <div class="button"  style="width: 50%" id="cancel" @click="prosseguir(false)">
                              {{$t('cancel')}}
                          </div>
                      </div>
                  </div>
              `,
            methods: {
              prosseguir(status) {
                this.$emit('close');
                if (status) {
                  sf.firstStep();
                }
              }
            }
          }, {}, {
            height: 'auto',
            resizable: false
          });
        } else {
          this.firstStep();
        }
      } else if (this.currentStep == 1) {
        this.showUnconsideredPlates = !this.showUnconsideredPlates;
        //this.secondStep();
      }
      // this.currentStep++;
    },
    visibilityModeChanged: function (mode) {
      this.exibitionMode = mode;
    },
    loadCenarios: function (nrcenarioResp, options = {}) {
      const { scenarioStateFromInsert = null } = options;
      return requestModule
        .postRequest(`getData`, {
          FROM: "CENARIOWOJ",
          PARAMS: {
            NRCENARIOCARD: null,
            CDFILIAL: Util.getFilterInSession().CDFILIAL,
            CDSERVFILI: Util.getFilterInSession().CDSERVFILI,
            DTMESCARD: Util.getFilterInSession().DTMESCARD,
            IDTIPORESTRICAO: Util.getFilterInSession().TPCONTRATO,
            NRORG: Util.getLocalVar("userData").NRORG,
            N_O: t('N_O'),
            CENARIO_ORIGINAL: t('CENARIO_ORIGINAL')
          }
        })
        .then(response => {
          this.cenarios = response.dataset.data;
          if (nrcenarioResp) {
            const cenarioSelecionado = this.cenarios.find(
              c => parseInt(c.NRCENARIOCARD) == parseInt(nrcenarioResp)
            );
            this.nrcenario = cenarioSelecionado
              ? {
                ...cenarioSelecionado,
                ...(scenarioStateFromInsert || {})
              }
              : null;
          } else {
            this.nrcenario = null;
          }
          return null;
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  #default-modal {
    .confirm-label {
      position: relative;
      display: block;
      margin: auto;
      text-align: center;
      padding: 15px 0;
      font-weight: 600;
    }

  .buttons-container {
    position: relative;
    display: flex;

    .button {
      bottom: 0;
      width: 168px;
      text-align: center;
      background-color: white;
      color: gray;
      font-size: 0.9rem;
      margin: 5px;

      &:hover {
        background-color: #dc143d;
        color: white;
      }
    }
  }
}
</style>
<style scoped lang="less">
@import (reference) url("../../assets/variables.less");

.card-usg-warning {
  position: relative;
  display: flex;

  .warning {
    font-weight: bold;
    position: relative;
    display: flex;
    margin: auto;
    border: solid 2px black;
    padding: 10px 7px 5px 7px;
    border-radius: 5px;

    span {
      text-align: center;
      max-width: 320px;

      div {
        display: inline-block;
        padding: 0px 6px 5px 6px;
        margin: 5px;
        vertical-align: middle;
        border: solid 1px black;
        border-radius: 5px;
      }
    }
  }
}

.loading-gif {
  .full;
  position: fixed;
  display: block;

  .default-animation;
  opacity: 0;
  pointer-events: none;
  z-index: 20;

  &.visible {
    opacity: 1;
  }

  img {
    .full;
    position: fixed;
    display: flex;
    margin: auto;
  }
}

.card-container-result {
  margin-top: 50px;
}

.card-container {
  @defaultHeight: calc(100vh - 53px);
  @altHeight: calc(100vh - 105px);
  margin: 0 5px;
  // scroll-snap-type: y mandatory;
  overflow-y: scroll;
  height: @defaultHeight;

  >div {

    //scroll-snap-align: start;
    &:not(:first-of-type) {
      padding-right: 15px;
    }
  }

  &.empty {
    height: @altHeight;

    >div {
      height: @altHeight;
    }
  }
}

.loader {
  position: relative;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  height: calc(100vh - 190px);
}

.otimizador-main-screen {
  position: relative;

  .headerAproach {
    margin-top: -5px;
  }

  .timer {
    position: absolute;
    text-align: center;
    display: flex;
    bottom: 0;
    right: 0;
    left: 0;

    .timer-center {
      display: flex;
      margin: auto;
      text-align: center;
      vertical-align: middle;
      font-size: 6rem;
      color: #fff;
      filter: drop-shadow(1px 1px 2px black);
    }

    font-family: "Share Tech Mono";
  }

  .otimizador-container {
    overflow: hidden auto;

    //height: calc(100vh - 160px);
    &.loading {
      padding: 0;
      height: -webkit-fill-available;
      overflow: hidden;
    }

    .arrow {
      z-index: 10;
      .sombra;
      .clicavel;
      .default-hover;
      position: fixed;
      right: 35px;
      bottom: 15px;
      border-radius: 100%;
      display: table;

      .arr {
        width: 60px;
        height: 60px;
        padding: 0;
        vertical-align: middle;
        display: flex;
        margin: auto;
        text-align: center;
        color: white;
        font-size: 30px;
        line-height: 20px;

        span {
          display: flex;
          margin: auto;
          font-size: 30px;
          padding: 0 5px 5px 8px;
        }
      }

      .desc {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        vertical-align: middle;
        margin: auto;
        display: table;
        font-size: 1.2rem;
        font-weight: 600;
        color: white;
        background: @vermelho;
        padding: 0 5px;
        border-radius: 5px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        opacity: 0;
        .default-animation;
      }

      &:hover .desc {
        background: @azul;
        opacity: 1;
        right: 45px;
      }
    }
  }

  .chat-container {
    position: relative;

    .title {
      padding-top: 15px;
      // border-top: solid 1px rgba(0, 0, 0, 0.1);
      display: block;
      text-align: center;
      margin: 30px 0 0px 0;
      font-size: 1.3rem;
      color: @vermelho;
    }

    .chart {
      display: table;
      margin: auto;
    }
  }
}
</style>
